import { Skeleton } from '@mui/material';

function HeaderLinkLoader(): JSX.Element {
  return <Skeleton variant="text" width={169} height={24} />;
}

export default HeaderLinkLoader;
